import { Component, Input } from '@builder.io/sdk';

import { formFields } from 'molecules/Form/config';
import { moleculeHeadingFields } from 'molecules/Heading/config';
import sectionFields from 'molecules/Section/config';

const conversionPanelFields = [
  ...moleculeHeadingFields,
  ...formFields(),
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const conversionPanelConfig = {
  name: 'Conversion Panel',
  inputs: conversionPanelFields,
} as Component;

export interface ConversionPanelConfigProps
  extends Omit<GenerateBuilder<typeof conversionPanelFields>, 'form'>, FormFieldProps {}

export default conversionPanelConfig;
